import { createApp, defineComponent } from "vue";

const InputSelector = defineComponent({
    template: `
        <div class="input">
            <label class="checklist-item">
                <div class="checklist-item__input">
                    <slot></slot>
                    <span class="checkbox-item__dot"></span>
                </div>

                <div class="checklist-item__title">
                    {{ label }}
                </div>
            </label>
        </div>
    `,

    props: [
        'label',
        'checked',
    ],
});

const InputRadio = defineComponent({
    components: {
        InputSelector,
    },

    template: `
        <InputSelector :label="label" :checked="modelValue == value">
            <input type="radio" :value="value" :checked="modelValue == value" @input="$emit('update:modelValue', $event.target.value)" class="input__input" />
        </InputSelector>
    `,

    props: [
        'value',
        'label',
        'modelValue'
    ],

    emits: [
        'update:modelValue'
    ],
});

const InputCheckboxes = defineComponent({
    components: {
        InputSelector,
        InputRadio,
    },

    template: `
        <InputSelector v-for="item in items" :label="item.title" :checked="values.includes(item.id)">
            <input type="checkbox" :value="item.id" v-model="values" class="input__input" />
        </InputSelector>
    `,

    props: [
        'items',
        'modelValue'
    ],

    emits: [
        'update:modelValue'
    ],

    data() {
        return {
            values: [],
        }
    },

    watch: {
        values(val) {
            this.$emit('update:modelValue', val);
        },
    }
});

export default class {
    public static init($uid: JQuery): void {
        const options = $uid.data('options');

        createApp({
            components: {
                InputRadio,
                InputCheckboxes,
            },

            template: `
                <div :class="{ 'vevent__register--no-pricegroup': !pricegroup }">
                    <template v-if="options.registerable">
                        <h2 class="vevent__title" v-html="options.title"></h2>

                        <div class="vevent__price-text mb-40 cmstext" v-html="options.headtext"></div>

                        <div class="vevent__register-inner">
                            <div class="vevent__register-prices article-body article-body--40 article-body--flat">
                                <img src="/theme/images/bg-register.svg" />

                                <div class="vevent__register-text cmstext vevent__body-text" v-html="lefttext"></div>
                            </div>

                            <div class="vevent__register-info">
                                <div class="article-body article-body--40">
                                    <div v-if="options.pricegroups">
                                        <h3>{{ options.title_pricegroupselect }}:</h3>

                                        <InputRadio v-for="item in options.pricegroups" v-model="pricegroup" :value="item.id" :label="item.title" />
                                    </div>

                                    <div v-if="options.addons.length" class="vevent__register-addons">
                                        <hr>

                                        <h3>{{ options.title_addonselect }}:</h3>

                                        <InputCheckboxes v-model="addons" :items="options.addons" />
                                    </div>
                                </div>

                                <div v-if="priceinfo" class="article-body article-body--40">
                                    <h3>{{ options.title_prices }}:</h3>

                                    <div class="vevent__register-priceinfo" v-html="priceinfo"></div>
                                </div>
                            </div>
                        </div>

                        <div v-if="options.footertext" class="vevent__register-footer cmstext" v-html="options.footertext"></div>

                        <div v-if="options.orderable" class="vevent__register-button mt-40">
                            <button type="button" class="vevent__register-submit button button--1" @click="submit" :disabled="!pricegroup">
                                {{ options.registerbuttontitle }}
                            </button>
                        </div>
                    </template>

                    <template v-if="!options.registerable && options.notactive">
                        <h2 v-html="options.notactive.title"></h2>

                        <div class="vevent__register-notactive">
                            <div class="cmstext" v-html="options.notactive.content"></div>
                        </div>
                    </template>
                </div>
            `,

            data() {
                return {
                    options: options,

                    lefttext: options.initext,

                    pricegroup: options.pricegroups?.length == 1 ? options.pricegroups[0].id : null,
                    addons: [],

                    priceinfo: null,
                };
            },

            created() {
                this.fetchInfo();
            },

            methods: {
                getData() {
                    return {
                        id: this.options.id,
                        group: this.pricegroup,
                        addons: this.addons.join(','),
                    };
                },

                async fetchInfo() {
                    if (!this.pricegroup) {
                        return;
                    }

                    const lang: string = $('html').prop('lang');
                    const data = this.getData();

                    const r = await $.ajax({
                        url: '/' + lang + '/api/wsevents/prices',
                        method: 'GET',

                        data: data,
                    }).promise();

                    this.lefttext = r.text;
                    this.priceinfo = r.info;
                },

                async submit() {
                    if (!this.pricegroup) {
                        return;
                    }

                    const lang: string = $('html').prop('lang');
                    const data = this.getData();

                    const r = await $.ajax({
                        url: '/' + lang + '/api/cart/set',
                        method: 'POST',

                        data: data,

                    }).promise();

                    if (r.redirect) {
                        window.location = r.redirect;
                    }
                },
            },

            watch: {
                pricegroup(val) {
                    this.fetchInfo();
                },

                addons(val) {
                    this.fetchInfo();
                },
            },
        }).mount($uid[0]);

    }
}
